import React, { useEffect, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
import { trackInitiateCheckout } from '../utils/trackAddToCart';
interface FloatingCTAProps {
  isOrderBumpChecked: boolean;
}
export function FloatingCTA({
  isOrderBumpChecked
}: FloatingCTAProps) {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      const checkoutSection = document.getElementById('checkout');
      if (checkoutSection) {
        // Mostramos el CTA flotante solo cuando el usuario ha hecho scroll
        // hasta la sección de la oferta (checkout)
        const showThreshold = checkoutSection.offsetTop - window.innerHeight / 2;
        if (latest > showThreshold) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      } else {
        // Fallback por si no encuentra el ID
        if (latest > 2000) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      }
    });
  }, [scrollY]);
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: isVisible ? 0 : 100
  }} transition={{
    duration: 0.3
  }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a]/90 backdrop-blur-md border-t border-[#222] p-4 md:hidden" data-id="element-212">
      <div className="flex items-center justify-between max-w-md mx-auto" data-id="element-213">
        <div className="flex flex-col" data-id="element-214">
          <span className="text-[#f5f0e8] font-serif font-bold" data-id="element-215">
            ${isOrderBumpChecked ? '19.98' : '9.99'} USD
          </span>
          <span className="text-[10px] text-[#8a8578] uppercase tracking-wider" data-id="element-216">
            {isOrderBumpChecked ? 'Trading en Paz + Psicología' : 'Trading en Paz'}
          </span>
        </div>
        <a href="https://pay.hotmart.com/I104339970M?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="px-6 py-2 bg-gradient-to-r from-[#b8942e] to-[#e8c84a] text-black font-bold text-sm rounded shadow-lg shadow-yellow-900/20" data-id="element-217">
          DEJAR DE SABOTEARME
        </a>
      </div>
    </motion.div>;
}